import { render, staticRenderFns } from "./ReEmail.vue?vue&type=template&id=98fbdeb8&scoped=true&"
import script from "./ReEmail.vue?vue&type=script&lang=js&"
export * from "./ReEmail.vue?vue&type=script&lang=js&"
import style0 from "./ReEmail.vue?vue&type=style&index=0&id=98fbdeb8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fbdeb8",
  null
  
)

export default component.exports